const COUNTRIES_COMMON = [
  { code: "BR", name: "Brazil" },
  { code: "DK", name: "Denmark" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "ES", name: "Spain" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "TR", name: "Turkey" },
  { code: "CA", name: "Canada" },
  { code: "IT", name: "Italy" },
  { code: "JP", name: "Japan" },
  { code: "NO", name: "Norway" },
];

const COUNTRIES_AIRLINES = [
  ...COUNTRIES_COMMON,
  { code: "SE", name: "Sweden" },
  { code: "MX", name: "Mexico" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GR", name: "Greece" },
  { code: "IE", name: "Ireland" },
];
const COUNTRIES_AIRPORTS = [
  ...COUNTRIES_COMMON,
  { code: "AU", name: "Australia" },
  { code: "CH", name: "Switzerland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "NZ", name: "New Zealand" },
];

export const countries = {
  airlines: COUNTRIES_AIRLINES,
  airports: COUNTRIES_AIRPORTS,
};

export const DEFAULT_SELECTED_COUNTRY = "US";
